import styled from 'styled-components';

import { Swiper } from '~/src/common/components/Swiper/Swiper';
import { media } from '~/src/common/theme/styles-constants';

/**
[Mobile]
- Affichage en pleine largeur via marge négative
- Décallage de la liste via padding-right
- Sur 2 colonnes, avec un gap de 8px
- Flèches de contrôle masquées
[Tablet]
- Affichage en pleine largeur via marge négative
- Décallage de la liste via padding-right
- Largeur de colonne par défaut 198px (surchargeable)
- Flèches de contrôle masquées
[Desktop]
- Affichage en pleine largeur via marge négative
- Remise à zéro du décallage de la liste
- Flèches de contrôle affichée
*/
export const SwiperEdgeToEdge = styled(Swiper)`
  --desktop-item-width: 198px;
  --mobile-right-space: 32px;
  --mobile-column-count: 2;

  && {
    --item-gap: 8px;
    --item-width: calc((100% - var(--item-gap)) / var(--mobile-column-count));
    --control-width: var(--body-padding);
    --control-outside: 1;
    --control-visibility: hidden;
    --list-rpadding: var(--mobile-right-space);
    --edge-to-edge: 1;

    ${media.S`
      --item-width: var(--desktop-item-width);
    `}

    ${media.XL`
      --item-gap: 16px;
      --list-rpadding: var(--list-hpadding);
      --control-visibility: visible;
    `}
  }
`;

/**
[Mobile]
- Affichage en pleine largeur via marge négative
- Décallage de la liste via padding-right
- Sur 2 colonnes, avec un gap de 8px
- Flèches de contrôle masquées
[Tablet]
- Affichage en pleine largeur via marge négative
- Décallage de la liste via padding-right
- Largeur de colonne par défaut 198px (surchargeable)
- Flèches de contrôle masquées
[Desktop]
- Affichage contraint dans le conteneur
- Remise à zéro du décallage de la liste
- Flèches de contrôle affichées à l'intérieur
*/
export const SwiperConstrained = styled(Swiper)`
  --desktop-item-width: 198px;
  --mobile-right-space: 32px;
  --mobile-column-count: 2;

  && {
    --item-gap: 8px;
    --item-width: calc((100% - var(--item-gap)) / var(--mobile-column-count));
    --control-width: var(--body-padding);
    --control-outside: 1;
    --control-visibility: hidden;
    --list-rpadding: var(--mobile-right-space);
    --edge-to-edge: 1;

    ${media.S`
      --item-width: var(--desktop-item-width);
    `}

    ${media.XL`
      --edge-to-edge: 0;
      --item-gap: 16px;
      --list-rpadding: var(--list-hpadding);
      --control-visibility: visible;
      --control-outside: 0;
    `}
  }
`;
